import { gql } from '@apollo/client';

export const REMOVE_CUSTOM_LINEITEM = gql`
    mutation RemoveCustomLineItems2($cartId: String!, $lineItemIds: [String!]!) {
        removeCustomLineItems(cartId: $cartId, lineItemIds: $lineItemIds) {
            id
        }
    }
`;
